export const fields = [
  { name: "types", type: "array", defaultValue: [], required: true },
  { name: "country", type: "string", defaultValue: "Canada", required: true },
  { name: "province", type: "string", defaultValue: "", required: false },
];

export const label = "Industry";
